import { render, staticRenderFns } from "./ProductAttributeSelect.vue?vue&type=template&id=498aea2a&scoped=true&"
import script from "./ProductAttributeSelect.vue?vue&type=script&lang=js&"
export * from "./ProductAttributeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498aea2a",
  null
  
)

export default component.exports